class ImageGridPagination extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
  }

  connectedCallback() {
    this.perPage = parseInt(this.getAttribute('per-page')) || 6;
    this.targetSelector = this.getAttribute('target');
    this.cards = document.querySelectorAll(this.targetSelector);

    this.applyMode();
    window.addEventListener("resize", () => this.applyMode());
  }

  applyMode() {
    if (window.innerWidth < 749) {
      // Mobile: use pagination
      this.totalPages = Math.ceil(this.cards.length / this.perPage);
      this.render();
      this.showPage(this.currentPage);
    } else {
      // Desktop: remove pagination and show all items
      this.innerHTML = "";
      this.cards.forEach(card => (card.style.display = "block"));
    }
  }

  render() {
    this.innerHTML = "";
    this.classList.add("image-grid-pagination");

    if (this.totalPages <= 1) return;

    for (let i = 1; i <= this.totalPages; i++) {
      const btn = document.createElement("button");
      btn.textContent = i;
      btn.addEventListener("click", () => {
        this.currentPage = i;
        this.showPage(this.currentPage);
      });
      this.appendChild(btn);
    }
  }

  showPage(page) {
    this.cards.forEach((card, i) => {
      card.style.display =
        i >= (page - 1) * this.perPage && i < page * this.perPage
          ? "block"
          : "none";
    });

    this.querySelectorAll("button").forEach((btn, i) => {
      btn.classList.toggle("active", i + 1 === page);
    });
  }
}

customElements.define("image-grid-pagination", ImageGridPagination);
